<template>
    <div id="pz">
     <div class="dokpz">
        <div class="title">{{ title }}</div>
	<div class="items">
		<div id='container' class='e-resizable'>
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="false" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected="rowSelected" :rowDeselected="rowSelected" :allowTextWrap='true' locale='pl-PL' :allowFiltering="true" :filterSettings="filterOptions" :rowHeight="80" height="100%" width="100%"> 
			<e-columns>
				<e-column field='ID_DOK_MAGAZYNOWEGO' headerText='ID' :visible="false"></e-column>
				<e-column field='numerPZ' headerText='Numer PZ' width='80'></e-column>
				<e-column field='dataPZ' headerText='Data PZ' type='date' format='yyyy-MM-dd' width='80'></e-column>
				<e-column field='nazwaKontrahenta' headerText='Nazwa kontrahenta' width='200'></e-column>
				<e-column field='ID_ARTYKULU' headerText='ID artykułu' width='100' :visible="false"></e-column>
				<e-column field='nazwaArtykulu' headerText='Nazwa artykułu' width='120'></e-column>
            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
		</div>
	</div>
     </div>
    <div class="wleft">
        <button class="wlabel"> WRÓĆ </button>
    </div>
    <div class="wcenter">
        <div id="scanning" style="display:none">
                <div class="spinner"></div>
        </div>
        <input type="text" style="opacity: 0;" id="skaner"></input>
        <label id="notfound" style="display:none;"></label>
        <button id="read" class="wlabel" style="display:none;">Zczytaj ze skanera</button>
    </div>	
    <div class="wright">
	<button class="wlabel"> PRZYJMIJ WYRÓB NA MAGAZYN</button>
    </div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
//import { L10n, setCulture } from '@syncfusion/ej2-base';
import { dokumenty_pz } from "./panel1_dane.js";
import * as CONFIG from "./config.js";
import axios from "axios";
import { polish } from "./polish.js";
import Storage from "./Storage";

//setCulture('pl-PL');

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);


export default {
  name: "dokumentypzwydanie",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: dokumenty_pz.items,
	data: [],
	url: "/agent/GALEK.Magazyn/GetDokumentPZPrzypisane",
	title: "PRZYJĘCIE WYROBU GOTOWEGO > ZLECENIA > LISTA DOKUMENTÓW PZ",
	x: 1,
        pageSettings: { pageSize: 5 },
	selectionOptions: { type: 'Multiple', enableSimpleMultiRowSelection: true, allowColumnSelection: false },
	gitem: [],
	filterOptions: {
        type: 'Menu',
        operators: {
          stringOperator: [
            { value: 'startsWith', text:'startsWith' },
            { value: 'endsWith', text:'endsWith' },
            { value: 'contains', text:'contains' }
          ],
        }
	},
	jwt: "",
        id_zlecenia: -1,
   }),
   provide: {
	grid: [Page, Sort, Filter]
   },
   methods: { 
	dataBound: function() {
        	//this.$refs.grid.autoFitColumns();
    	},
	rowSelected(args) {
        	//let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
        	//alert(selectedrowindex); // To alert the selected row indexes.
        	let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		if (selectedrecords.length > 0) {
			this.gitem = selectedrecords;		
			//alert(JSON.stringify(this.gitem));
		} else {
			this.gitem = [];
		}
	},
	drukujclick() {
		//alert("Drukuj");
		if (this.gitem.length > 0) {
			var mags = "" + this.gitem[0].ID_DOK_MAGAZYNOWEGO;
			if (this.gitem.length > 1) {
				for (var i = 1; i < this.gitem.length; i++) {
					mags += "," + this.gitem[i].ID_DOK_MAGAZYNOWEGO;
				}
			}	 
			this.$router.push({ path: "/nosnikopakowanie", query: { mag: mags, prev: "dokumentpzprzyjecie", id_zlecenia: this.id_zlecenia }});
		} else {
			alert("Nie wybrano elementu do przyjęcia. Proszę zaznaczyć co najmniej 1 element z listy.");
		}
	},
	skanerclick() {
                console.log("focus...");
                document.querySelector("#skaner").focus();
        },
        skanerstart() {
                console.log("scanning started...");
                document.querySelector("#read").style.display='none';
                document.querySelector("#notfound").style.display='none';
                document.querySelector("#scanning").style.display='block';
        },
        skanerend() {
                console.log("scanning finished...");
                document.querySelector("#scanning").style.display='none';
                document.querySelector("#notfound").style.display='block';
                document.querySelector("#read").style.display='none';
        },
        skanertext() {
                var valx = document.querySelector("#skaner").value;
                console.log("VALUE pasted: " + valx);
                document.querySelector("#skaner").value = "";
                let success = this.pickUpRow(valx);
                if (!success) {
                        // lets try again without last part 
                        let parts = valx.split('/');
                        if (parts.length > 0) {
                                parts.pop();
                                let nparts = parts.join('/');
                                console.log("NEW pattern to check: " + nparts);
                                this.pickUpRow(nparts); 
                        }
                }
                this.skanerend();
        },
	pickUpRow(val) {
                let found = false;
                const rows = document.querySelectorAll(".e-row");
                for (let x = 0; x < rows.length; x++) {
                        const cells = rows[x].querySelectorAll(".e-rowcell");
                        if (cells && cells.length > 1) {
                                let row = cells[1].innerHTML;
                                if (row && row === val) {
                                        found = true;
                                        console.log("scanned value found at row: " + x);
                                        document.querySelector("#notfound").innerHTML='';
                                        this.$refs.grid.selectRow(x, true);
                                        break;
                                }
                        }
                }
                if (!found) {
                        console.log("scanned value not found");
                        document.querySelector("#notfound").innerHTML='Nie znaleziono';
                }
                return found;
        },
	gridfocus() {
                console.log("GRID FOCUS...");
                this.skanerclick();
        },
	wrocclick() {
		this.$router.push({ path: "/zleceniaartykul" });
	},
	getData() {
      		return axios
        		.get(CONFIG.API_URL + this.url + "/" + this.id_zlecenia, {
          		headers: {
            			"Content-Type": "application/x-www-form-urlencoded",
            			"Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
          		}
        		})
        		.then(response => {
          			return response.data;
        		})
        		.catch(e => {
          			alert("ERROR" + e);
        		});
	},
   },
   mounted() {
	var params = this.$route.query;
        if (params["id_zlecenia"]) {
                this.id_zlecenia = params["id_zlecenia"];
        }
	var that = this;
	Storage.loadJWT("jwt").then(resp => {
		//alert(resp.access_token);
		that.jwt = resp.access_token;
		that.getData().then(data => {
			that.data = data;
		});
	});
	document.querySelector(".wright").addEventListener('click', function() { that.drukujclick(); } );
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
	document.querySelector(".wcenter").addEventListener('click', function() { that.skanerclick(); } );
        document.querySelector("#skaner").addEventListener('focus', function() { that.skanerstart(); } );
	document.querySelector(".e-grid").addEventListener('focusin', function() { that.gridfocus(); } );

        let reading = false;
        let UPC = '';
        document.querySelector("#skaner").addEventListener('keydown', function (e){

                const textInput = e.key || String.fromCharCode(e.keyCode);
                const targetName = e.target.localName;
                let newUPC = '';
                if (textInput && textInput.length === 1){
                        newUPC = UPC+textInput;
                        UPC = newUPC;
                
                        if (newUPC.length >= 10) {
                                //console.log('barcode scanned:  ', newUPC);
                                UPC = "";
                        } 
                } 
                if(!reading) {
                        reading = true;
                        setTimeout(() => {
                                newUPC = "";
                                reading = false;
                                that.skanertext();
                                //that.skanerclick();
                        }, 500);  //500 works fine for me but you can adjust it
                }

        });
	// autoinitiate skaner
        this.skanerclick();
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.e-resizable {
  resize: both;
  overflow: auto;
  /*border: 1px solid red;*/
  padding: 1px;
  height: 500px;
  min-height: 550px;
  min-width: 250px;
}
.drukuj {
	width: 100px;
	height: 50px;
	padding-top: 10px;
	text-align: right;
	float: right;
}

.title {
	text-align: left;
	width: 100%;
}
.items {
	float:none;
}
.dokpz {
	float: left;
	width: 96%;
	padding: 2% 2% 0% 2%;
}
.wcenter {
        width: 60%;
        margin-left: 20%;
        margin-right: 20%;
        height: 50px;
        position:fixed;
        bottom: 50px;
}
.wright {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
#read {
        margin-left: auto;
        margin-right: auto;
}
.spinner{
        display:none;
        margin-left: auto;
        margin-right: auto;
        width: 64px;
        height: 64px;
        border: 8px solid;
        border-color: #3d5af1 transparent #3d5af1 transparent;
        border-radius: 50%;
        animation: spin 1.2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#notfound {
   font: 10px;
   font-style: italic;
   color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/DokumentPZPrzyjecie.vue